module.exports = __webpack_public_path__ + "icon_services_status_disabled.3c31f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_services_status_disabled.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_services_status_disabled.svg
// module chunks = main